import { apiClient } from "./ApiClient";

export const retrieveUserReportsApi = (componentName) =>
  apiClient.get(`/api/user/preferences/${componentName}`);

export const retrieveUserComponentSettingsApi = (componentName, reportName) =>
  apiClient.get(`/api/user/preferences/${componentName}/${reportName}`);

export const saveUserComponentSettingsApi = (componentName, reportName, visibleColumnsJson) =>
  apiClient.post(`/api/user/preferences/${componentName}/${reportName}`, {
    visibleColumns: visibleColumnsJson,
  });
export const deleteUserComponentSettingsApi = (componentName, reportName) =>
  apiClient.post(`/api/user/preferences/delete/${componentName}/${reportName}`);